// extracted by mini-css-extract-plugin
export default {"cateTitle":"Common_cateTitle__8LbKV"};